import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QuestionComponent } from '../abstract/question.component';

@Component({
  selector: 'question-text-type',
  templateUrl: './question-text.component.html',
  styleUrls: ['./question-text.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionTextComponent extends QuestionComponent {}
